import React, { useEffect } from 'react';
import { LayoutDashboard, MessageSquare, Settings, Heart, Stethoscope, LogOut, X, ChevronRight  } from 'lucide-react';

export default function Sidebar({ activeTab, setActiveTab, isOpen, toggleSidebar, bookingsCount, chatsCount }) {
  const DESKTOP_BP = 1024;

  // Close on Escape key (mobile only)
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen && window.innerWidth <= DESKTOP_BP) {
        toggleSidebar();
      }
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [isOpen, toggleSidebar]);

  const handleNavClick = (tab) => {
    setActiveTab(tab);
    // Auto-close the drawer on mobile after navigation
    if (window.innerWidth <= DESKTOP_BP) {
      toggleSidebar();
    }
  };
  
  const handelExit =()=>{
    localStorage.removeItem('token');
    window.location.reload();
  }
  return (
    <>
      {/* Dark overlay — only visible on mobile when sidebar is open */}
      <div
        className={`sidebar-overlay ${isOpen ? 'open' : ''}`}
        onClick={toggleSidebar}
        aria-hidden="true"
      />

      {/* Floating tab on the right edge — only shown on mobile when sidebar is closed */}
      <button
        className={`sidebar-toggle-floating ${!isOpen ? 'visible' : ''}`}
        onClick={toggleSidebar}
        aria-label="فتح القائمة"
        title="فتح القائمة"
      >
        <ChevronRight size={20} />
      </button>

      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="logo">
            <div className="logo-icon-wrapper">
              <Stethoscope size={22} fill="#c9a84c" color="#c9a84c" />

            </div>
            <div className="logo-text">
              <span className="logo-title">عيادة دكتور محمد خالد توفيق </span>
              <span className="logo-subtitle">نظام إدارة الحجوزات</span>
            </div>
          </div>
          {/* Close button — CSS hides it on desktop, shows on mobile */}
          <button className="close-btn" onClick={toggleSidebar} aria-label="إغلاق القائمة">
            <X size={20} />
          </button>
        </div>

        <nav className="sidebar-nav">
          <div className="nav-section">
            <span className="nav-section-title">القائمة الرئيسية</span>

            <button
              className={`nav-item ${activeTab === 'bookings' ? 'active' : ''}`}
              onClick={() => handleNavClick('bookings')}
            >
              <div className="nav-icon-wrapper">
                <LayoutDashboard size={20} />
              </div>
              <span className="nav-label">الحجوزات</span>
              <span className="nav-badge">{bookingsCount}</span>
            </button>

            <button
              className={`nav-item ${activeTab === 'chats' ? 'active' : ''}`}
              onClick={() => handleNavClick('chats')}
            >
              <div className="nav-icon-wrapper">
                <MessageSquare size={20} />
              </div>
              <span className="nav-label">المحادثات</span>
              {chatsCount > 0 && <span className="nav-badge pulse">{chatsCount}</span>}
            </button>
          </div>

          {/* <div className="nav-section">
            <span className="nav-section-title">الإعدادات</span>
            <button className="nav-item">
              <div className="nav-icon-wrapper">
                <Settings size={20} />
              </div>
              <span className="nav-label">الإعدادات</span>
            </button>
          </div> */}
        </nav>

        <div className="sidebar-footer">
          <div className="admin-card">
            <div className="admin-avatar">
              <Stethoscope size={18} />
            </div>
            <div className="admin-details">
              <span className="admin-name">د. محمد خالد توفيق </span>
              <span className="admin-role">استشاري النساء والتوليد</span>
            </div>
          </div>
          <button className="logout-btn" onClick={handelExit}>
            <LogOut size={16} />
            <span>تسجيل الخروج</span>
          </button>
        </div>
      </aside>
    </>
  );
}